import { render, staticRenderFns } from "./NewsDetailMain.vue?vue&type=template&id=b4212612&"
import script from "./NewsDetailMain.vue?vue&type=script&lang=js&"
export * from "./NewsDetailMain.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetailMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4212612')) {
      api.createRecord('b4212612', component.options)
    } else {
      api.reload('b4212612', component.options)
    }
    module.hot.accept("./NewsDetailMain.vue?vue&type=template&id=b4212612&", function () {
      api.rerender('b4212612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Press/News/NewsDetailMain.vue"
export default component.exports